import { ReactNode } from 'react';

import { CheckCircleRounded, Error, Warning } from '@mui/icons-material';
import { Typography } from '@mui/material';

export type ComplianceStatus =
  | 'compliant'
  | 'questionable'
  | 'violation'
  | 'unknown';

export const complianceMapper: Record<
  ComplianceStatus,
  { icon: ReactNode; text: string }
> = {
  compliant: {
    icon: <CheckCircleRounded color="success" />,
    text: 'Compliant'
  },
  questionable: {
    icon: <Warning color="warning" />,
    text: 'Questionable'
  },
  violation: {
    icon: <Error color="error" />,
    text: 'Violation'
  },
  unknown: {
    icon: <></>,
    text: '—'
  }
};

type AdType =
  | 'questionable'
  | 'sponsored'
  | 'promoted'
  | string
  | null
  | undefined;

export const formatAdType = (adType: AdType): React.ReactNode => {
  if (!adType) {
    return <>—</>;
  }

  if (adType === 'questionable') {
    return <Typography>Possible Ad</Typography>;
  }

  return (
    <Typography>{adType.charAt(0).toUpperCase() + adType.slice(1)}</Typography>
  );
};
